import React, {Component} from 'react';
import {Row, Col, Button, Modal, Container, Form} from 'react-bootstrap';
import Switch from 'react-switch';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
var dateFormat = require('dateformat');
class ItemMasterEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        value: {
          drugCode: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.drugCode
            : null,
          drugName: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.drugName
            : null,
          descp: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.descp
            : null,

          unitPrice: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.unitPrice
            : null,
          taxPernct: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.taxPernct
            : null,
          taxAmnt: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.taxAmnt
            : null,

          unitCost: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.unitCost
            : null,

          remarks: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.remarks
            : null,
          batchNo: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.batchNo
            : null,

          mfgDate: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.mfgDate
            : null,
          expiryDate: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.expiryDate.date
            : null,
          hsnCode: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.hsnCode
            : null,

          mrp: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.mrp
            : null,

          id: this.props.ItemMasterdtList
            ? this.props.ItemMasterdtList.id
            : null,
          ManufactrDate: '',
          ExpryDate: '',
        },
      },
    };

    this.handleChangedate = this.handleChangedate.bind(this);
    this.handleChangeexpiryDate = this.handleChangeexpiryDate.bind(this);
  }

  handleChangedate = date => {
    this.setState({
      value: {...this.state.value, ManufactrDate: date, mfgDate: date},
    });
  };

  handleChangeexpiryDate = date => {
    this.setState({
      value: {...this.state.value, ExpryDate: date, expiryDate: date},
    });
  };

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === 'drugCode') {
      this.setState({
        value: {...this.state.value, drugCode: value},
      });
    } else if (name === 'drugName') {
      this.setState({
        value: {...this.state.value, drugName: value},
      });
    } else if (name === 'descp') {
      this.setState({
        value: {...this.state.value, descp: value},
      });
    } else if (name === 'unitPrice') {
      this.setState({
        value: {...this.state.value, unitPrice: value},
      });
    } else if (name === 'taxPernct') {
      this.setState({
        value: {...this.state.value, taxPernct: value},
      });
    } else if (name === 'taxAmnt') {
      this.setState({
        value: {...this.state.value, taxAmnt: value},
      });
    } else if (name === 'unitCost') {
      this.setState({
        value: {...this.state.value, unitCost: value},
      });
    } else if (name === 'remarks') {
      this.setState({
        value: {...this.state.value, remarks: value},
      });
    } else if (name === 'batchNo') {
      this.setState({
        value: {...this.state.value, batchNo: value},
      });
    } else if (name === 'mfgDate') {
      this.setState({
        value: {...this.state.value, mfgDate: value},
      });
    } else if (name === 'expiryDate') {
      this.setState({
        value: {...this.state.value, expiryDate: value},
      });
    } else if (name === 'hsnCode') {
      this.setState({
        value: {...this.state.value, hsnCode: value},
      });
    } else if (name === 'mrp') {
      this.setState({
        value: {...this.state.value, mrp: value},
      });
    }
  };

  submit = () => {
    const value = this.state.value;

    this.props.EditItemmaster(this.state.value);
    this.props.closeEditModel();
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        drugCode:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.drugCode,
        drugName:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.drugName,
        descp: nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.descp,
        unitPrice:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.unitPrice,

        taxPernct:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.taxPernct,
        taxAmnt:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.taxAmnt,
        unitCost:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.unitCost,
        remarks:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.remarks,

        batchNo:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.batchNo,
        mfgDate:
          nextProps.ItemMasterdtList &&
          dateFormat(nextProps.ItemMasterdtList.mfgDate, 'mediumDate'),
        expiryDate:
          nextProps.ItemMasterdtList &&
          dateFormat(nextProps.ItemMasterdtList.expiryDate, 'mediumDate'),

        hsnCode:
          nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.hsnCode,
        mrp: nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.mrp,

        id: nextProps.ItemMasterdtList && nextProps.ItemMasterdtList.id,
      },
    });
  }

  render() {
    return (
      <div>
        <Modal
          show={this.props.showitemmasterEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
            closeButton
          >
            <Modal.Title>Item Master</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <div style={{marginTop: '10px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="drugCode">
                            <Form.Label> Item Code </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="drugCode"
                              onChange={this.onChange}
                              value={this.state.value.drugCode}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="drugName">
                            <Form.Label> Item Name </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="drugName"
                              onChange={this.onChange}
                              value={this.state.value.drugName}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <Form.Group controlId="descp">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows="1"
                            name="descp"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.descp}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>

              <div style={{marginTop: '10px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="unitPrice">
                            <Form.Label> Unit Price </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="unitPrice"
                              onChange={this.onChange}
                              value={this.state.value.unitPrice}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="taxPernct">
                            <Form.Label> Tax Percentage </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="taxPernct"
                              onChange={this.onChange}
                              value={this.state.value.taxPernct}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="taxAmnt">
                            <Form.Label> Tax Amount </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="taxAmnt"
                              onChange={this.onChange}
                              value={this.state.value.taxAmnt}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>

              <div style={{marginTop: '10px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="unitCost">
                            <Form.Label>Unit Cost </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="unitCost"
                              onChange={this.onChange}
                              value={this.state.value.unitCost}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div>
                        <Form.Group controlId="remarks">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows="1"
                            name="remarks"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.remarks}
                          />
                        </Form.Group>
                      </div>
                    </Form> */}
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="mrp">
                            <Form.Label>MRP </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="mrp"
                              onChange={this.onChange}
                              value={this.state.value.mrp}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div>
                        <div>
                          <Form.Group controlId="batchNo">
                            <Form.Label> Batch Number </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="batchNo"
                              onChange={this.onChange}
                              value={this.state.value.batchNo}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form> */}
                    <Form>
                      <div>
                        <Form.Group controlId="remarks">
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows="1"
                            name="remarks"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.remarks}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>

              <div style={{marginTop: '15px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div style={{ maxWidth: 250, margin: "auto" }}>
                        <Form.Group controlId="mfgDate">
                          <Form.Label>Maufacture Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            value={this.state.value.mfgDate}
                            selected={this.state.value.ManufactrDate}
                            name="mfgDate"
                            onChange={this.handleChangedate}
                            dateFormat="dd-MM-yyyy"
                          ></DatePicker>
                        </Form.Group>
                      </div>
                    </Form> */}
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="batchNo">
                            <Form.Label> Batch Number </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="batchNo"
                              onChange={this.onChange}
                              value={this.state.value.batchNo}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div style={{ maxWidth: 250, margin: "auto" }}>
                        <Form.Group controlId="expiryDate">
                          <Form.Label>Expiry Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            value={this.state.value.expiryDate}
                            selected={this.state.value.ExpryDate}
                            name="expiryDate"
                            onChange={this.handleChangeexpiryDate}
                            dateFormat="dd-MM-yyyy"
                            minDate={new Date()}
                          ></DatePicker>
                        </Form.Group>
                      </div>
                    </Form> */}
                    <Form>
                      <div style={{maxWidth: 250, margin: 'auto'}}>
                        <Form.Group controlId="mfgDate">
                          <Form.Label>Mfg Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            value={this.state.value.mfgDate}
                            selected={this.state.value.ManufactrDate}
                            name="mfgDate"
                            onChange={this.handleChangedate}
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    {/* <Form>
                      <div>
                        <div>
                          <Form.Group controlId="hsnCode">
                            <Form.Label> Hsn Code </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="hsnCode"
                              onChange={this.onChange}
                              value={this.state.value.hsnCode}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form> */}
                    <Form>
                      <div style={{maxWidth: 250, margin: 'auto'}}>
                        <Form.Group controlId="expiryDate">
                          <Form.Label>Expiry Date</Form.Label>
                          <DatePicker
                            className="invoiceDatePicker"
                            value={this.state.value.expiryDate}
                            selected={this.state.value.ExpryDate}
                            name="expiryDate"
                            onChange={this.handleChangeexpiryDate}
                            dateFormat="dd-MM-yyyy"
                            minDate={new Date()}
                          />
                        </Form.Group>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>

              <div style={{marginTop: '15px'}}>
                <Row>
                  <Col xs={12} sm={6} md={4} lg={4}>
                    <Form>
                      <div>
                        <div>
                          <Form.Group controlId="hsnCode">
                            <Form.Label> HSN Code </Form.Label>
                            <Form.Control
                              type="text"
                              autoComplete="off"
                              name="hsnCode"
                              onChange={this.onChange}
                              value={this.state.value.hsnCode}
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </div>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{backgroundColor: '#f0f3f5'}}>
            <Button type="submit" onClick={this.submit}>
              Update
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default ItemMasterEdit;
